module.exports = __webpack_public_path__ + "static/media/10.b16cc6e2.png";